import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { PanelLeftClose, PanelLeftOpen } from "@/shared/ui/icons";

export function SidebarBrand({
  hasShops,
  collapsed,
  onToggle,
}: {
  hasShops: boolean;
  collapsed: boolean;
  onToggle: () => void;
}) {
  const { t } = useTranslation();
  const toggleLabel = collapsed ? t("shell.actions.expandSidebar") : t("shell.actions.collapseSidebar");
  return (
    <div className="sidebar-brand">
      {hasShops ? (
        <span className="brand-mark">A</span>
      ) : (
        <NavLink
          to="/dashboard"
          className="brand-mark"
          aria-label={t("shell.noShop.title")}
          title={t("shell.noShop.title")}
        >
          A
        </NavLink>
      )}
      <span className="brand-name">AccelaSearch</span>
      <button className="sidebar-collapse" onClick={onToggle} aria-label={toggleLabel} title={toggleLabel}>
        {collapsed ? <PanelLeftOpen /> : <PanelLeftClose />}
      </button>
    </div>
  );
}
